export class ClipboardHelper {
	static copyToClipboard(text: string): void {
		const tempElement = document.createElement("textarea");
		tempElement.value = text;
		document.body.appendChild(tempElement);
		tempElement.select();
		document.execCommand("copy");
		document.body.removeChild(tempElement);
	}

	static getFromClipboard(): string {
		const tempElement = document.createElement("textarea");
		document.body.appendChild(tempElement);
		tempElement.focus();
		document.execCommand("paste");
		const text = tempElement.textContent;
		document.body.removeChild(tempElement);
		return text ?? "";
	}
}
